import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  currentFarm: {},
  farms: [],
  inFarmContext: false,
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  setCurrentFarm: ['currentFarm', 'onSuccess', 'onError'],
  resetCurrentFarm: [],
  setCurrentFarmProperties: ['properties', 'onSuccess', 'onError'],
  loadUserFarms: ['onSuccess', 'onError'],
  loadUserFarmsSuccess: ['farms'],
  saveFarm: ['farm', 'onSuccess', 'onError'],
  inactivateFarm: ['farm', 'onSuccess', 'onError'],
  removeFarm: ['farm', 'onSuccess', 'onError'],
  enterFarmContext: [],
  leaveFarmContext: [],
  farmError: ['error']
})

const saveFarm = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeFarm = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const inactivateFarm = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const setCurrentFarm = (state = INITIAL_STATE, { currentFarm }) => ({
  ...state,
  currentFarm
})

const resetCurrentFarm = (state = INITIAL_STATE) => ({
  ...state,
  currentFarm: INITIAL_STATE.currentFarm
})

const setCurrentFarmProperties = (state = INITIAL_STATE, { properties }) => ({
  ...state,
  currentFarm: {
    ...state.currentFarm,
    properties
  }
})

const loadUserFarms = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const loadUserFarmsSuccess = (state = INITIAL_STATE, { farms }) => ({
  ...state,
  farms
})

const enterFarmContext = (state = INITIAL_STATE) => ({
  ...state,
  inFarmContext: true
})

const leaveFarmContext = (state = INITIAL_STATE) => ({
  ...state,
  inFarmContext: false
})

const farmError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.FARM_ERROR]: farmError,

  [Types.SAVE_FARM]: saveFarm,
  [Types.INACTIVATE_FARM]: inactivateFarm,
  [Types.REMOVE_FARM]: removeFarm,

  [Types.LOAD_USER_FARMS]: loadUserFarms,
  [Types.LOAD_USER_FARMS_SUCCESS]: loadUserFarmsSuccess,

  [Types.SET_CURRENT_FARM]: setCurrentFarm,
  [Types.SET_CURRENT_FARM_PROPERTIES]: setCurrentFarmProperties,
  [Types.RESET_CURRENT_FARM]: resetCurrentFarm,

  [Types.ENTER_FARM_CONTEXT]: enterFarmContext,
  [Types.LEAVE_FARM_CONTEXT]: leaveFarmContext,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as FarmTypes,
  Creators as FarmActions
}
